import { render, staticRenderFns } from "./OnlineCustomWorkFlowTable.vue?vue&type=template&id=6b8f4a9a&"
import script from "./OnlineCustomWorkFlowTable.vue?vue&type=script&lang=js&"
export * from "./OnlineCustomWorkFlowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports